export const SOLUTIONS = [
  {
    slug: "dificultati-financiare",
    image: "https://images.unsplash.com/photo-1560493676-04071c5f467b?q=80&w=1600&auto=format&fit=crop",
    icon: "TrendingDown",
    ro: {
      name: "Dificultăți financiare",
      short: "Datorii, rate, cash-flow blocat. Reconstruim echilibrul financiar al fermei, pas cu pas.",
      problem: [
        "Ratele la bancă, furnizorii care așteaptă plata, un sezon slab care a dat totul peste cap. Dificultățile financiare nu apar dintr-o dată — se adună încet, iar când devin vizibile, par deja fără ieșire.",
        "Adevărul este că majoritatea situațiilor financiare ale fermelor pot fi reparate. Dar nu cu panică și nu cu încă un credit pus peste. Ci cu o imagine clară, o strategie de renegociere și un plan de cash-flow construit pe realitatea fermei tale.",
      ],
      what: [
        "Analiză completă a situației financiare: datorii, scadențe, costuri pe hectar, active",
        "Strategie de renegociere cu bănci și furnizori — resalonări, refinanțări, perioade de grație",
        "Plan de cash-flow pe 12 luni, adaptat calendarului agricol",
        "Prioritizarea plăților și eliminarea costurilor care nu produc",
        "Monitorizare și ajustare lunară până la stabilizare",
      ],
      steps: [
        { t: "Discuția inițială (gratuită)", d: "Înțelegem situația fără să judecăm. Confidențial, la telefon sau la fermă." },
        { t: "Analiza și planul", d: "Punem toate cifrele pe masă și construim împreună planul de redresare." },
        { t: "Execuție alături de tine", d: "Te însoțim la renegocieri și urmărim planul lună de lună." },
      ],
    },
    en: {
      name: "Financial difficulties",
      short: "Debt, instalments, blocked cash flow. We rebuild the farm's financial balance, step by step.",
      problem: [
        "Bank instalments, suppliers waiting for payment, one bad season that turned everything upside down. Financial difficulties do not appear overnight — they build up slowly, and by the time they become visible, they already look hopeless.",
        "The truth is that most farm financial situations can be repaired. But not with panic, and not with one more loan stacked on top. It takes a clear picture, a renegotiation strategy and a cash-flow plan built on the reality of your farm.",
      ],
      what: [
        "Complete financial analysis: debts, deadlines, per-hectare costs, assets",
        "Renegotiation strategy with banks and suppliers — rescheduling, refinancing, grace periods",
        "12-month cash-flow plan adapted to the agricultural calendar",
        "Payment prioritisation and elimination of non-productive costs",
        "Monthly monitoring and adjustment until stabilisation",
      ],
      steps: [
        { t: "Initial discussion (free)", d: "We understand the situation without judging. Confidential, by phone or at the farm." },
        { t: "Analysis and plan", d: "We put all the numbers on the table and build the recovery plan together." },
        { t: "Execution alongside you", d: "We accompany you to renegotiations and track the plan month by month." },
      ],
    },
  },
  {
    slug: "management-agricol",
    image: "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?q=80&w=1600&auto=format&fit=crop",
    icon: "Tractor",
    ro: {
      name: "Management agricol",
      short: "Operațiuni, planificare, oameni. Transformăm ferma dintr-un efort zilnic într-un sistem care funcționează.",
      problem: [
        "Multe ferme funcționează pe memorie și obicei: tratamentele se decid pe moment, costurile se află la final de an, iar totul trece printr-un singur om. Cât ferma este mică, merge. Când crește, sistemul cedează.",
        "Managementul agricol înseamnă să transformi ferma într-un sistem: planificare pe culturi, bugete pe hectar, responsabilități clare și decizii bazate pe cifre, nu pe presiunea zilei.",
      ],
      what: [
        "Planificare operațională pe culturi și campanii agricole",
        "Bugete și costuri pe hectar — știi profitul înainte de recoltă",
        "Structură de organizare și delegare, ca ferma să nu depindă de un singur om",
        "Indicatori simpli de urmărit lunar, fără birocrație inutilă",
        "Pregătirea fermei pentru extindere sau asociere",
      ],
      steps: [
        { t: "Audit operațional", d: "Vedem cum funcționează ferma azi: fluxuri, oameni, costuri, blocaje." },
        { t: "Sistemul de management", d: "Construim structura potrivită dimensiunii și stilului tău de lucru." },
        { t: "Implementare și ajustare", d: "Rămânem alături de echipă până sistemul merge de la sine." },
      ],
    },
    en: {
      name: "Agricultural management",
      short: "Operations, planning, people. We turn the farm from a daily effort into a system that works.",
      problem: [
        "Many farms run on memory and habit: treatments decided on the spot, costs discovered at year-end, and everything passing through one person. While the farm is small, it works. When it grows, the system breaks.",
        "Agricultural management means turning the farm into a system: crop planning, per-hectare budgets, clear responsibilities and decisions based on numbers, not on the pressure of the day.",
      ],
      what: [
        "Operational planning for crops and agricultural campaigns",
        "Per-hectare budgets and costs — know your profit before harvest",
        "Organisation and delegation structure, so the farm does not depend on one person",
        "Simple monthly indicators, without useless bureaucracy",
        "Preparing the farm for expansion or association",
      ],
      steps: [
        { t: "Operational audit", d: "We see how the farm works today: flows, people, costs, bottlenecks." },
        { t: "The management system", d: "We build the structure that fits your farm's size and your working style." },
        { t: "Implementation and tuning", d: "We stay alongside the team until the system runs by itself." },
      ],
    },
  },
  {
    slug: "decizii-business",
    image: "https://images.unsplash.com/photo-1605000797499-95a51c5269ae?q=80&w=1600&auto=format&fit=crop",
    icon: "Compass",
    ro: {
      name: "Sprijin în decizii de business",
      short: "Investiții, extindere, asocieri. Un al doilea creier lângă al tău, atunci când miza este mare.",
      problem: [
        "Cumperi teren sau nu? Investești în utilaje sau în irigații? Intri în asociere sau rămâi independent? Deciziile mari ale fermei se iau rar, dar au consecințe pe zece ani. Iar de cele mai multe ori le iei singur, sub presiune.",
        "Noi venim ca al doilea creier: analizăm scenariile, calculăm riscurile și îți spunem sincer — inclusiv atunci când răspunsul corect este „nu acum”.",
      ],
      what: [
        "Analiză de investiție: cost, randament, timp de recuperare, scenarii negative",
        "Evaluare de oportunități: terenuri, asocieri, contracte, culturi noi",
        "Plan de afaceri pe 3–5 ani, cu repere clare de decizie",
        "Sprijin în negocieri importante: bănci, parteneri, cumpărători",
        "A doua opinie independentă înainte de orice semnătură majoră",
      ],
      steps: [
        { t: "Înțelegem miza", d: "Ce decizie ai de luat, până când și ce te costă dacă greșești." },
        { t: "Analizăm scenariile", d: "Numărăm, comparăm și testăm varianta bună și varianta rea." },
        { t: "Decizi cu spatele acoperit", d: "Pleci cu o recomandare clară și cu planul de execuție." },
      ],
    },
    en: {
      name: "Business decision support",
      short: "Investments, expansion, partnerships. A second brain next to yours when the stakes are high.",
      problem: [
        "Buy land or not? Invest in machinery or irrigation? Join an association or stay independent? The farm's big decisions are rare, but their consequences last ten years. And most of the time you make them alone, under pressure.",
        "We come in as a second brain: we analyse the scenarios, calculate the risks and tell you honestly — including when the right answer is „not now”.",
      ],
      what: [
        "Investment analysis: cost, return, payback time, downside scenarios",
        "Opportunity assessment: land, partnerships, contracts, new crops",
        "3–5 year business plan with clear decision milestones",
        "Support in important negotiations: banks, partners, buyers",
        "Independent second opinion before any major signature",
      ],
      steps: [
        { t: "We understand the stakes", d: "What decision you face, by when, and what a mistake would cost." },
        { t: "We analyse the scenarios", d: "We count, compare and test the good case and the bad case." },
        { t: "You decide covered", d: "You leave with a clear recommendation and an execution plan." },
      ],
    },
  },
  {
    slug: "accesare-fonduri",
    image: "https://images.unsplash.com/photo-1592982537447-7440770cbfc9?q=80&w=1600&auto=format&fit=crop",
    icon: "Landmark",
    ro: {
      name: "Accesare fonduri & oportunități",
      short: "APIA, fonduri europene, programe de investiții. Alegem programul potrivit și construim dosarul care câștigă.",
      problem: [
        "Anual, sute de milioane de euro ajung în agricultura românească prin subvenții și programe europene. Totuși, mulți fermieri renunță înainte să înceapă — sau pierd dosarul din cauza unor greșeli mici de execuție.",
        "Secretul nu este să aplici peste tot, ci să alegi programul potrivit pentru etapa fermei tale și să construiești proiectul pe strategia fermei, nu pe formular.",
      ],
      what: [
        "Evaluare de eligibilitate și hartă a oportunităților pentru ferma ta",
        "Strategie de accesare: ce programe, în ce ordine, cu ce investiții",
        "Coordonarea construirii dosarului și a documentației tehnice",
        "Plan de implementare și decont, ca proiectul să nu se blocheze după aprobare",
        "Legarea fiecărui leu european de planul pe termen lung al fermei",
      ],
      steps: [
        { t: "Evaluarea oportunităților (gratuită)", d: "Stabilim la ce programe ești eligibil și care merită efortul." },
        { t: "Strategia și dosarul", d: "Construim proiectul pe fundația fermei, nu invers." },
        { t: "Implementare fără blocaje", d: "Însoțim proiectul până la decontarea finală." },
      ],
    },
    en: {
      name: "Funding & opportunities",
      short: "APIA, European funds, investment programmes. We pick the right programme and build the file that wins.",
      problem: [
        "Every year, hundreds of millions of euros reach Romanian agriculture through subsidies and European programmes. Yet many farmers give up before they start — or lose the file over small execution mistakes.",
        "The secret is not to apply everywhere, but to choose the programme that fits your farm's stage and to build the project on the farm's strategy, not on the form.",
      ],
      what: [
        "Eligibility assessment and opportunity map for your farm",
        "Access strategy: which programmes, in what order, with which investments",
        "Coordination of the application file and technical documentation",
        "Implementation and reimbursement plan, so the project does not stall after approval",
        "Linking every European euro to the farm's long-term plan",
      ],
      steps: [
        { t: "Opportunity assessment (free)", d: "We establish which programmes you are eligible for and which are worth the effort." },
        { t: "Strategy and file", d: "We build the project on the farm's foundation, not the other way around." },
        { t: "Implementation without blockages", d: "We accompany the project until final reimbursement." },
      ],
    },
  },
  {
    slug: "protectia-afacerii",
    image: "https://images.unsplash.com/photo-1523741543316-beb7fc7023d8?q=80&w=1600&auto=format&fit=crop",
    icon: "ShieldCheck",
    ro: {
      name: "Protecția afacerii agricole",
      short: "Risc climatic, de piață, financiar, operațional. Construim scutul fermei înainte de furtună, nu în mijlocul ei.",
      problem: [
        "Nicio fermă nu poate controla vremea, piața sau politica agricolă. Dar poate controla cât de expusă este. O singură furtună de grindină, un contract prost semnat sau un sezon fără rezervă pot șterge ani de muncă.",
        "Protecția afacerii înseamnă un sistem: asigurări alese corect, contracte negociate din timp, diversificare, rezerve și un plan pentru scenariul în care totul merge prost.",
      ],
      what: [
        "Audit complet de risc: climatic, de piață, financiar, operațional, juridic",
        "Strategie de asigurare — ce merita asigurat și ce nu",
        "Structură de rezerve și plasament de siguranță pentru sezoanele grele",
        "Protecție contractuală: verificarea acordurilor înainte de semnare",
        "Plan de continuitate: ferma merge mai departe indiferent ce se întâmplă",
      ],
      steps: [
        { t: "Auditul de risc", d: "Identificăm punctele prin care ferma ta poate fi doborâtă." },
        { t: "Construim scutul", d: "Prioritizăm și implementăm măsurile de protecție, în ordinea impactului." },
        { t: "Testăm și menținem", d: "Revizuim protecția anual, pe măsură ce ferma crește." },
      ],
    },
    en: {
      name: "Protecting the agricultural business",
      short: "Climatic, market, financial, operational risk. We build the farm's shield before the storm, not in the middle of it.",
      problem: [
        "No farm can control the weather, the market or agricultural policy. But it can control how exposed it is. A single hailstorm, a badly signed contract or one season without reserves can erase years of work.",
        "Business protection means a system: correctly chosen insurance, contracts negotiated in time, diversification, reserves and a plan for the scenario where everything goes wrong.",
      ],
      what: [
        "Complete risk audit: climatic, market, financial, operational, legal",
        "Insurance strategy — what is worth insuring and what is not",
        "Reserve structure and safety cushion for hard seasons",
        "Contractual protection: reviewing agreements before signing",
        "Continuity plan: the farm goes on no matter what happens",
      ],
      steps: [
        { t: "The risk audit", d: "We identify the points through which your farm can be brought down." },
        { t: "We build the shield", d: "We prioritise and implement protection measures, by order of impact." },
        { t: "We test and maintain", d: "We review protection annually, as the farm grows." },
      ],
    },
  },
];

export const getSolution = (slug) => SOLUTIONS.find((s) => s.slug === slug);
